import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import { AppLocalStorage } from '../utils/local-storage.util';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(private msalService: MsalService) {}

  async getAccessToken(): Promise<string | null> {
    try {
      // Check for Teams SSO token first
      const teamsToken = sessionStorage.getItem('teams_sso_token');
      const teamsExpiry = sessionStorage.getItem('teams_sso_expiry');
      
      if (teamsToken && teamsExpiry) {
        const expiryTime = parseInt(teamsExpiry, 10) * 1000; // Convert to milliseconds
        const now = Date.now();
        
        if (expiryTime > now) {
          return teamsToken;
        } else {
          sessionStorage.removeItem('teams_sso_token');
          sessionStorage.removeItem('teams_sso_expiry');
        }
      }

      // Initialize MSAL
      await this.msalService.instance.initialize();
      
      // Get active account
      const activeAccount = this.msalService.instance.getActiveAccount();
      if (!activeAccount) {
        return null;
      }
  
      // Acquire token silently
      const request: SilentRequest = {
        scopes: [...environment.apiConfig.scopes],
        account: activeAccount
      };
  
      const result: AuthenticationResult = await this.msalService.instance.acquireTokenSilent(request);
      
      // Store session
      const session = {
        token: result.accessToken,
        id: Date.now().toString(),
        expiry: result.expiresOn?.toLocaleString() ?? null,
      };
      AppLocalStorage.set("SESSION", "SESSION", session);
  
      return result.accessToken;
    } catch (err) {
      console.error('[TokenService] Failed to acquire token:', err);
      return null;
    }
  }
}